function NotSignedInPage() {
    return (        
        <div className="msds-text-lead msds-text-clear-blue text-center">
            You're not signed in - please sign in to manage integrations
        </div>        
    );
}

export default NotSignedInPage;
